import LoginHistory from './LoginHistory'

export default LoginHistory;